import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../hoc/toJS'
import getData from '../../functions/getData'
import {
    PROGRAM_MOVIEMAPPING_ITEMS,
    PROGRAM_CINEMAS,
    PREVIEW_MOVIES_ITEMS,
    PROGRAM_CLI_MOVIES_ITEMS,
    PROGRAM_PY_MOVIES_ITEMS,
    PROGRAM_KH_MOVIES_ITEMS,
    PROGRAM_COMP_MOVIES_ITEMS,
    PROGRAM_DIESEL_MOVIES_ITEMS,
    PROGRAM_CORTEC_MOVIES_ITEMS,
    PROGRAM_MARSX_MOVIES_ITEMS,
    PROGRAM_VISTA_MOVIES_ITEMS,
    CLI_CINEMA_CLIENT_ID,
} from '../../constants/state'
import actionTypes from '../../actions/actionTypes'
import PageMetaMappingPage from '../../components/PageMetaMapping/present/PageMetaMappingPage'

const mapStateToProps = (state) => ({
    movieMappings: getData(state, PROGRAM_MOVIEMAPPING_ITEMS),
    cinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    pmPreviewMovies: getData(state, PREVIEW_MOVIES_ITEMS),
    cliMovies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    pyMovies: getData(state, PROGRAM_PY_MOVIES_ITEMS),
    khMovies: getData(state, PROGRAM_KH_MOVIES_ITEMS),
    compesoMovies: getData(state, PROGRAM_COMP_MOVIES_ITEMS),
    dieselMovies: getData(state, PROGRAM_DIESEL_MOVIES_ITEMS),
    cortecMovies: getData(state, PROGRAM_CORTEC_MOVIES_ITEMS),
    marsxMovies: getData(state, PROGRAM_MARSX_MOVIES_ITEMS),
    vistaMovies: getData(state, PROGRAM_VISTA_MOVIES_ITEMS),
})

const mapDispatchToProps = (dispatch) => ({
    onMerge: (sourceMetaMoviePk, destinationMetaMoviePk, keptTitle) => dispatch({
        type: actionTypes.META_MERGE_REQUEST,
        payload: { sourceMetaMoviePk, destinationMetaMoviePk, keptTitle },
    }),
    onMove: (providerMovieKey, providerMovieUuid, sourceMetaMoviePk, destinationMetaMoviePk) => dispatch({
        type: actionTypes.META_MOVE_REQUEST,
        payload: { providerMovieKey, providerMovieUuid, sourceMetaMoviePk, destinationMetaMoviePk },
    }),
    onSplit: (providerMovieKey, providerMovieUuid, sourceMetaMoviePk) => dispatch({
        type: actionTypes.META_SPLIT_REQUEST,
        payload: { providerMovieKey, providerMovieUuid, sourceMetaMoviePk },
    }),
})

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PageMetaMappingPage)
